export function unregister() {
  if ('serviceWorker' in navigator) {
    void navigator.serviceWorker.ready.then((registration) => {
      void registration.unregister();
    });
  }
}
